import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Cancellations and Refunds | Ship&Play',
  description:
    'Learn about our cancellation and refund policies. ' +
    'We offer flexible options to fit your changing travel plans.',
  alternates: {
    canonical: 'https://www.shipplay.com/cancellations-and-refunds',
  },
}

export default metadata
